import { getApolloClient } from '../lib/getApolloClient';
import {
  AVAILABLE_WORKERS_FOR_JOB_CRITERIA_QUERY,
  AVAILABLE_WORKERS_FOR_JOB_QUERY,
} from './availableWorkers.gql';
import { User } from '../generated/gql-types';

export const fetchUsersAvailableForJob = async (
  jobId: string,
): Promise<User[] | null> => {
  try {
    const { data } = await getApolloClient().query({
      query: AVAILABLE_WORKERS_FOR_JOB_QUERY,
      variables: { jobId },
    });
    if (data.getUsersAvailableForJob) {
      return data.getUsersAvailableForJob;
    }
    return [];
  } catch (error) {
    console.error('Error fetching users available for job: ', error);
    return [];
  }
};

export const fetchUsersAvailableForJobCriteria = async (
  classificationId: string,
  clientId: string,
  startDate: string,
  endDate: string,
  lat: number | undefined | null,
  lng: number | undefined | null,
): Promise<User[] | null> => {
  try {
    const { data } = await getApolloClient().query({
      query: AVAILABLE_WORKERS_FOR_JOB_CRITERIA_QUERY,
      variables: { classificationId, startDate, endDate, lat, lng, clientId },
    });
    if (data.getUsersAvailableForJobCriteria) {
      return data.getUsersAvailableForJobCriteria;
    }
    return [];
  } catch (error) {
    console.error(
      'Error fetching users available for job circumstances: ',
      error,
    );
    return [];
  }
};

export const availableWorkersActions = {
  fetchUsersAvailableForJob,
  fetchUsersAvailableForJobCriteria,
};
